import { createContext, useContext, useState, useEffect } from "react";
import { axiosAuth } from "../api/axiosConfig";
import { useUserContext } from "./UserContext";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  // Read the stored customer during the first render (not in an effect) so
  // consumers never see the "Admin" default before it's swapped for the real
  // selection — that briefly fetched the wrong data and made RecentSamples
  // reset a restored location.
  const [selectedCustomer, setSelectedCustomer] = useState(() => {
    const storedCustomer = localStorage.getItem("selectedCustomer");
    return storedCustomer ? JSON.parse(storedCustomer) : { customer: "Admin" };
  });
  const [customers, setCustomers] = useState([]);
  const { user } = useUserContext();

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const { data } = await axiosAuth.get("/admin/get-all-customers");
        setCustomers(data.customers);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };

    if (user && user.role === "admin") {
      fetchCustomers();
    }
  }, [user]);

  const updateSelectedCustomer = (customer) => {
    setSelectedCustomer(customer);
    localStorage.setItem("selectedCustomer", JSON.stringify(customer));
  };

  return (
    <AdminContext.Provider
      value={{
        selectedCustomer,
        updateSelectedCustomer,
        customers,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
export const useAdminContext = () => {
  return useContext(AdminContext);
};
